import type { ValidationError } from "@common/types";

export class CriterionEditorViewModel
{
    isOpen = false;

    criterionId: number | null = null;

    name = '';
    description = '';

    isGoal = false;

    nameError: string | null = null;

    show(criterionId: number, name: string, description: string | null, isGoal: boolean)
    {
        this.criterionId = criterionId;
        this.name = name;
        this.description = description ?? '';
        this.isGoal = isGoal;
        this.clearValidationErrors();

        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;

        this.criterionId = null;
        this.reset();
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        const nameError = errors.find(e => e.ErrorCode?.startsWith("Name."));
        this.nameError = nameError?.Error ?? null;
    }

    reset()
    {
        this.name = '';
        this.description = '';
        this.isGoal = false;
        this.clearValidationErrors();
    }
}
